import { useIntl } from 'react-intl';

const WithValueMessage = ({ messageId, name, value }) => {
  const intl = useIntl();
  return intl.formatMessage({ id: messageId }).replace(`{${name}}`, value);
};

export default WithValueMessage;
